/**
 * Side panel — always shows the player's limb silhouette at a fixed
 * small size. Focus-locked enemy details live in the separate
 * FocusPanel window; the side panel doesn't grow when a target is
 * selected.
 */

import type { Guard } from '../sim/guard';
import type { Player } from '../sim/player';
import { renderLimbSilhouette } from './limbSilhouette';
import type { GameWindow } from './window';

export class SidePanel {
  private readonly root: HTMLElement;

  constructor(win: GameWindow) {
    this.root = document.createElement('div');
    this.root.className = 'sp-root';
    win.body.appendChild(this.root);
  }

  update(player: Player, _guards: readonly Guard[]): void {
    this.root.innerHTML = '';
    this.root.appendChild(renderLimbSilhouette(player.body, 'YOU'));
    const hint = document.createElement('div');
    hint.className = 'sp-empty sp-hint';
    if (player.focusedTargetId !== null) {
      hint.innerHTML = 'Focused. See <b>FOCUS</b> panel.';
    } else {
      hint.innerHTML = 'Press <span class="sp-key">F</span> to lock a target.';
    }
    this.root.appendChild(hint);
  }
}
